import { defineComponent as p, openBlock as l, createElementBlock as a, mergeProps as u, unref as o, renderSlot as g, createElementVNode as e, createCommentVNode as H } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, V = { key: 2 }, f = { key: 3 }, h = { key: 4 }, w = { key: 5 }, k = {
  name: "ScalarIconArrowLineDown"
}, L = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = M(s);
    return (i, t) => (l(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      g(i.$slots, "default"),
      o(n) === "bold" ? (l(), a("g", Z, t[0] || (t[0] = [
        e("path", { d: "M47.51,112.49a12,12,0,0,1,17-17L116,147V32a12,12,0,0,1,24,0V147l51.51-51.52a12,12,0,0,1,17,17l-72,72a12,12,0,0,1-17,0ZM216,204H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (l(), a("g", m, t[1] || (t[1] = [
        e("path", {
          d: "M200,112l-72,72L56,112Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M122.34,189.66a8,8,0,0,0,11.32,0l72-72A8,8,0,0,0,200,104H136V32a8,8,0,0,0-16,0v72H56a8,8,0,0,0-5.66,13.66ZM180.69,120,128,172.69,75.31,120ZM224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216Z" }, null, -1)
      ]))) : o(n) === "fill" ? (l(), a("g", V, t[2] || (t[2] = [
        e("path", { d: "M50.34,117.66A8,8,0,0,1,56,104h64V32a8,8,0,0,1,16,0v72h64a8,8,0,0,1,5.66,13.66l-72,72a8,8,0,0,1-11.32,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : o(n) === "light" ? (l(), a("g", f, t[3] || (t[3] = [
        e("path", { d: "M51.76,116.24a6,6,0,0,1,8.48-8.48L122,169.51V32a6,6,0,0,1,12,0V169.51l61.76-61.75a6,6,0,0,1,8.48,8.48l-72,72a6,6,0,0,1-8.48,0ZM216,210H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : o(n) === "regular" ? (l(), a("g", h, t[4] || (t[4] = [
        e("path", { d: "M50.34,117.66a8,8,0,0,1,11.32-11.32L120,164.69V32a8,8,0,0,1,16,0V164.69l58.34-58.35a8,8,0,0,1,11.32,11.32l-72,72a8,8,0,0,1-11.32,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : o(n) === "thin" ? (l(), a("g", w, t[5] || (t[5] = [
        e("path", { d: "M53.17,114.83a4,4,0,0,1,5.66-5.66L124,174.34V32a4,4,0,0,1,8,0V174.34l65.17-65.17a4,4,0,1,1,5.66,5.66l-72,72a4,4,0,0,1-5.66,0ZM216,212H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  L as default
};
